import React from 'react';

const FormSecurityNotice = () => {
    return (
        <div className="mt-2 pt-4 border-t border-white/[0.08] mb-6 mx-6 text-center">
            <div className="inline-flex flex-wrap items-center justify-center gap-1.5 text-xs text-neutral-400">
                <span>Have questions? Check</span>
                <a 
                    href="/faq.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-400 hover:text-primary-300 underline font-medium transition-colors"
                >
                    FAQ
                </a>
                <span>or</span>
                <a 
                    href="/contact.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary-400 hover:text-primary-300 underline font-medium transition-colors"
                >
                    Contact Us
                </a>
            </div>
            <p className="text-[10px] text-neutral-500 mt-1.5 text-center leading-relaxed">
                <svg className="w-3.5 h-3.5 text-emerald-400/80 inline-block align-[-2px] mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                <span>Security notice: We never initiate contact first. Always verify official links.</span>
            </p>
        </div>
    );
};

export default FormSecurityNotice;
